import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { ProductIcon } from '../components/icons/BrandIcons';
import { PRODUCT_LINES } from '../data/products';
import MotionReveal from '../motion/MotionReveal';

export default function Products() {
  return (
    <motion.main
      id="main"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <Navigation />
      <PageHero
        kicker="Product Universe"
        title="Four product lines, one technical partner"
        subtitle="From vivid color to invisible functionality — engineered for every polymer challenge."
        variant="extrusion"
        theme="products"
      />
      <div className="products-detail">
        {PRODUCT_LINES.map((line) => (
          <MotionReveal key={line.id} className="product-block" id={line.id}>
            <div>
              <div className="product-block__icon">
                <ProductIcon name={line.icon} size={32} />
              </div>
              <h2>{line.name}</h2>
              <p className="product-block__tag">{line.tagline}</p>
            </div>
            <div>
              <p className="product-block__desc">{line.description}</p>
              <div className="product-solutions">
                {line.solutions.map((s) => (
                  <span key={s}>{s}</span>
                ))}
              </div>
              <Link to="/contact" className="btn-p" style={{ marginTop: 24, display: 'inline-block' }}>
                Request {line.name} Sample
              </Link>
            </div>
          </MotionReveal>
        ))}
      </div>
      <Footer />
    </motion.main>
  );
}
